<template>
  <div class="page-box">
    <h4 class="page-box__title">待确认费用</h4>
    <el-form class=""
             :model="searchData"
             ref="searchForm"
             label-width="100px"
             :inline="true"
             @submit.native.prevent>
      <el-form-item label="费用产生时间">
        <el-date-picker v-model="billDateValue"
                        @change="changeBillDateValue"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="运单号">
        <el-input v-model="searchData.nos"
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchData.state"
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option v-for="item in statusList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" style="margin-left: 50px;">查询</el-button>
    </el-form>
    <div class="" style="margin: 15px auto">
      <el-button type="primary"
                 @click="mergeConfirm"
                 :disabled="tableDataSelectValue.length<1">合并确认</el-button>
    </div>
    <el-table :data="tableData"
              @selection-change="selectionChangeChange"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              align="center"
              size="mini"
              highlight-current-row
              style="width: 100%"
              border>
      <el-table-column label=""
                       type="selection"
                       width="40"></el-table-column>
      <el-table-column label="序号"
                       type="index"
                       align="center"
                       width="60"></el-table-column>
      <el-table-column label="运单号"
                       align="center"
                       min-width="130"
                       prop=""></el-table-column>
      <el-table-column label="费用名称"
                       align="center"
                       min-width="130"
                       prop=""></el-table-column>
      <el-table-column label="应收金额"
                       align="center"
                       min-width="130"
                       prop=""></el-table-column>
      <el-table-column label="费用产生时间"
                       align="center"
                       min-width="130"
                       prop=""></el-table-column>
      <el-table-column label="状态"
                       align="center"
                       width="100"
                       prop=""></el-table-column>
      <el-table-column label="操作"
                       align="center"
                       min-width="160"
                       prop="">
        <template slot-scope="scope">
          <span class="table-button-plain color-gary"
                @click="showCostDetails(scope.row.id,scope.row)">查看详情</span>
          <span class="table-button-plain color-primary"
                @click="confirmItem(scope.row.id,scope.row)">确认</span>
          <span class="table-button-plain color-danger"
                @click="rejectItem(scope.row.id,scope.row)">拒绝</span>
          <!--<el-button type=""-->
                     <!--size="mini"-->
                     <!--@click="showCostDetails(scope.row.id,scope.row)"-->
                     <!--plain >详情</el-button>-->
          <!--<el-button type="primary"-->
                     <!--@click="confirm(scope.row.id,scope.row)"-->
                     <!--size="mini"-->
                     <!--plain >确认</el-button>-->
          <!--<el-button type="danger"-->
                     <!--size="mini"-->
                     <!--plain >拒绝</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="paging-row"
                   background
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="[10,20,30,40,50]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalListNum">
    </el-pagination>

    <el-dialog title="费用详情"
               :visible.sync="visibleCostDetails"
               class=""
               width="700px"
               center>
      <el-table :data="tableData"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                align="center"
                size="mini"
                highlight-current-row
                style="width: 100%"
                border>
        <el-table-column label="序号"
                         type="index"
                         align="center"
                         width="60"></el-table-column>
        <el-table-column label="费用类型"
                         align="center"
                         min-width="130"
                         prop=""></el-table-column>
        <el-table-column label="价格"
                         align="center"
                         min-width="130"
                         prop=""></el-table-column>
        <el-table-column label="费用详情"
                         align="center"
                         min-width="130"
                         prop=""></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {disposeSearchData} from "@/assets/js/utils";
  export default {
      name: "waitConfirmed",
      data(){
        return {
          loading:false,
          /* 筛选 */
          searchData:{
            state:'1',
            nos:'',//运单号
            beginTime:'', // 开始时间
            endTime:'', // 结束时间
          },
          /* 表格 */
          tableData:[{id:'fgdfg12',no:'test123456'}],
          tableDataSelectValue:[],
          /* 分页参数 */
          pageSize:10,
          totalListNum:10,
          currentPage: 1,

          /* 选择框 数据 */
          billDateValue:[],
          statusList:[
            {id:'',name:'全部'},
            {id:'1',name:'待确认'},
            {id:'2',name:'已确认'},
            {id:'3',name:'已拒绝'},
          ],

          /* 详情 */
          visibleCostDetails: false,
        }
      },
      methods:{
        /**
         * 拼接搜索参数
         */
        jointSearchData(){
          let data = {
            pageNo:this.currentPage,
            pageSize:this.pageSize,
          };
          data = Object.assign(data,this.searchData);
          disposeSearchData(data);
          return data;
        },
        /**
         * 搜索
         */
        search() {
          this.handleCurrentChange();
        },
        /**
         * 获取 列表
         */
        getList(){
          let data = this.jointSearchData();
          this.loading = true;
          return this.axios.post('/testAPI',data)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.tableData = [];
                this.totalListNum = 10;
                return this.$message.info(res.data.message||"服务器繁忙");
              }
              this.tableData = res.data.data.dataList;
              this.totalListNum = res.data.data.totalCount;
              return Promise.resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.tableData = [];
            });
        },
        /**
         * pageSize 改变时会触发：选择每页显示条数
         */
        handleSizeChange(val, type) {
          this.pageSize = val;
          this.handleCurrentChange();
        },
        /**
         * currentPage 改变时会触发：选择页数
         */
        handleCurrentChange(val = 1, type) {
          this.currentPage = val;
          this.getList();
        },
        /**
         * 其他
         */
        /*选择变化*/
        selectionChangeChange(value){
          this.tableDataSelectValue = value;
        },
        /*合并确认*/
        mergeConfirm(){
          let ids = this.tableDataSelectValue.map(res=>res.id);
          if(ids.length<=0) return this.$message.error('至少选择一条数据');
          this.$confirm('此操作将确认选中的多条费用项, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            this.$message('已确认');
          }).catch(()=>{

          });
        },
        /*确认*/
        confirmItem(id,row){
          this.$confirm('此操作将确认该费用项, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            this.$message('已确认');
          }).catch(()=>{

          });

        },
        /*拒绝*/
        rejectItem(id,row){
          this.$confirm('此操作将拒绝该费用项, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error'
          }).then(() => {
            this.$message('已拒绝');
          }).catch(()=>{

          });

        },
        /*变更时间*/
        changeBillDateValue(value){
          if(!value) value = [];
          this.searchData.beginTime = value[0]||'';
          this.searchData.endTime = value[1]||'';
        },
        showCostDetails(){
          this.visibleCostDetails = true;
        },
        hideCostDetails(){
          this.visibleCostDetails = false;
        },
      }
    }
</script>

<style scoped>
  .edit-form__input{
    width: 350px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/waitConfirmed.vue